import { VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React, { ReactNode } from 'react';
import { ImageBackground, View, ScrollView, useWindowDimensions, StyleSheet } from 'react-native';

import CoverBacgroundImage from '../../../assets/img/genial-cover-image.png';

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  transparency: {
    position: 'absolute',
    backgroundColor: 'rgba(34, 34, 34, 0.55)',
    zIndex: -1,
  },
  background: {
    position: 'absolute',
    zIndex: -2,
  },
});

export const SignedOutWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { width, height } = useWindowDimensions();
  const isDesktop = useBreakpointValue({
    base: false,
    lg: true,
  });

  return (
    <View
      style={[
        styles.flex,
        { width, height },
        !isDesktop && { backgroundColor: Color['neutral.white'] },
      ]}>
      {isDesktop && (
        <>
          <View style={[styles.transparency, { width, height }]} />
          <ImageBackground
            source={{ uri: CoverBacgroundImage }}
            alt="background"
            resizeMode="cover"
            style={[styles.background, { width, height }]}
          />
        </>
      )}
      <ScrollView
        style={[styles.flex, { minHeight: height }]}
        contentContainerStyle={{ minHeight: height }}>
        <VStack
          space={Spacing['stack.xs']}
          flex={1}
          p={{ md: Spacing['stack.xxs'], lg: Spacing['stack.xs'] }}>
          {children}
        </VStack>
      </ScrollView>
    </View>
  );
};

SignedOutWrapper.displayName = 'SignedOutWrapper';
